export default {"name":"NovaComponents-HomePage-gui-icu","comments":[],"messages":{"NovaComponents-HomePage-gui-icu.visibilityMenuButton.label":"Show"}}